import { createMemoStyles } from '@wds/utils';
import { HeaderTheme } from '../../theme';

const useStyles = createMemoStyles(({ spacing, palette }: HeaderTheme) => ({
  infoMenu: {
    display: 'flex',

    '& > div > div > .wds-overlay': {
      top: spacing[7],
    },
  },
  descriptionBox: {
    whiteSpace: 'normal',
  },
  footnote: {
    padding: [spacing[1], spacing[5], spacing[6], spacing[5]],
    borderTop: [1, 'solid', palette.text.darkMuted],
    whiteSpace: 'normal',
  },
}));

export default useStyles;
